import type { RendersUserModal } from "./types";

declare global {
  interface Window {
    __rootErrorBoundary: RendersUserModal | undefined;
  }
}

export const setRootErrorBoundary = (errorBoundary: RendersUserModal) => {
  window.__rootErrorBoundary = errorBoundary;
};
